
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Panel from 'primevue/panel';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import gdbx from '@/store/modules/gdbx';
import { TableItemFormatter } from '@/components/reports-v3/components/elements/charts/helpers/tableItemFormatter';

@Component({
	components: { Panel, DataTable, Column },
})
export default class TableCollapseToggle extends Vue {
	@Prop({ default: () => [] }) public readonly tableDatas!: any[];
	@Prop({ default: () => [] }) public readonly tableFields!: any[];
	@Prop({ default: 'Summary' }) public readonly buttonName!: string;
	@Prop() public sortBy?: string;
	@Prop({ default: true }) public sortDesc!: boolean;
	@Prop({ default: false }) public visible!: boolean;
	@Prop({ default: false }) public stickyHeader!: boolean | string;
    @Prop({default: true}) public toggleable?: boolean;

	public mySortBy: string = '';
	public mySortDesc: string = '';

	@Watch('sortBy', { immediate: true })
	public onSortByChange(newValue: string, oldValue: string) {
		this.mySortBy = newValue;
	}
	@Watch('sortDesc', { immediate: true })
	public onSortDescChange(newValue: string, oldValue: string) {
		this.mySortDesc = newValue;
	}

	public get currencySymbol() {
		return gdbx.currencySymbol;
	}

	public processHeaderName(col: any) {
		if (col && typeof col === 'object' && col.title !== undefined) {
			return col.title;
		}
		const name = (col && typeof col === 'object') ? col.key : col;
		const newString = name.replaceAll('_', ' ');
		const finalString = newString
			.toLowerCase()
			.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
		return finalString;
	}

	public formatLocal(option: any, value: any) {
		if (option) {
			return option(value);
		}

		return value;
	}

	public isSplitCurrency(formatter: any, value: any): boolean {
		if (!formatter) {
			return false;
		}
		const result = formatter(value);
		return result && typeof result === 'object' && result.__splitCurrency === true;
	}

	public isCurrencyFormatter(formatter: any): boolean {
		const currencyFormatters = [
			TableItemFormatter.currency,
			TableItemFormatter.currencyWithDecimals,
			TableItemFormatter.currencySplit,
			TableItemFormatter.currencySplitWithDecimals,
		];
		return currencyFormatters.includes(formatter);
	}

	public getHeaderStyle(col: any): object {
		const style: any = { 'background-color': '#e0e7ff' };
		if (col && col.textAlign) {
			style['text-align'] = col.textAlign;
		}
		return style;
	}

	public isNumeric(formatter: any, col?: any): string {
		if (col && col.textAlign) {
			return 'text-align: ' + col.textAlign + '; white-space: nowrap;';
		}
		const numericFormatters = [
			TableItemFormatter.currency,
			TableItemFormatter.currencyWithDecimals,
			TableItemFormatter.currencySplit,
			TableItemFormatter.currencySplitWithDecimals,
			TableItemFormatter.basic,
			TableItemFormatter.basicInteger,
			TableItemFormatter.basicWithDecimals,
			TableItemFormatter.percentage,
			TableItemFormatter.percentageWithDecimal,
		];
		if (numericFormatters.includes(formatter) || (col && col.numeric)) {
			return 'text-align: right; white-space: nowrap;';
		}
		return 'text-align: left;';
	}
}
